module.exports = __webpack_public_path__ + "img/Aerith.7d302d84.png";